import React from 'react';
import Gaming from './Gaming';

/** Game tab — Vast KVM VM + Wolf + Moonlight + Tailscale */
const Game = () => <Gaming mode="game" />;

export default Game;
